import { render, staticRenderFns } from "./MultiselectDropdown.vue?vue&type=template&id=aa8b9838&scoped=true&"
import script from "./MultiselectDropdown.vue?vue&type=script&lang=js&"
export * from "./MultiselectDropdown.vue?vue&type=script&lang=js&"
import style0 from "./MultiselectDropdown.vue?vue&type=style&index=0&id=aa8b9838&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8b9838",
  null
  
)

export default component.exports